import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

export const useHandleApolloError = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Error Boundary" });

  return (err: unknown, errorMessage?: string) => {
    window.parentIFrame?.scrollTo(0, 0);
    toast.error(errorMessage || t("Server error try later"));
  };
};
